import { InvoicePaymentUpsertDto } from '../../dto/invoice-payment-upsert.dto';
import { PaymentSource } from 'src/app/revenue/shared/payment-source/payment-source.model';
import { PaymentSourceService } from '../../../revenue/shared/payment-source/payment-source.service';
import { PaymentTypeService } from '../../../revenue/shared/payment-types/payment-type.service';
import { InvoiceUpsertDto } from '../../dto/invoice-upsert.dto';
import { Component, OnInit, Input } from '@angular/core';
import { PaymentTypeDto } from 'src/app/revenue/shared/payment-types/dto/payment-type.dto';

@Component({
  selector: 'wl-invoice-payments-list',
  templateUrl: './invoice-payments-list.component.html',
  styleUrls: ['./invoice-payments-list.component.less'],
    standalone: false
})
export class InvoicePaymentsListComponent implements OnInit {
  @Input() invoice: InvoiceUpsertDto;
  @Input() flatPaymentIds: Array<number>;

  public paymentTypes: Array<PaymentTypeDto>;
  public paymentSources: Array<PaymentSource>;

  constructor(private _paymentTypeService: PaymentTypeService, private _paymentSourceService: PaymentSourceService) {}

  ngOnInit() {
    this._paymentTypeService.getPaymentTypes().then((data) => {
      this.paymentTypes = data;
    });

    this._paymentSourceService.getPaymentSources().then((data: Array<PaymentSource>) => {
      this.paymentSources = data;
    });
  }

  public removePayment(lineItemIndex: number, paymentIndex: number) {
    const payment = this.invoice.LineItems[lineItemIndex].Payments[paymentIndex];
    if (payment.PaymentID > 0) {
      payment.DeletePayment = true;
    } else {
      this.invoice.LineItems[lineItemIndex].Payments.splice(paymentIndex, 1);
    }
  }
}
